export const ModalAddAvatarTranslationsUk = {
  'Add profile picture': 'Додати зображення профілю',
};
